import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridApi, GridReadyEvent, RowClickedEvent, ICellRendererParams, FilterChangedEvent, PaginationChangedEvent, FilterModifiedEvent, FilterOpenedEvent } from 'ag-grid-community';
import { AlertService } from 'src/app/_services/alert.service';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentUploadService } from './document-upload.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BtnCellRenderer2 } from 'src/app/common/button-cell-renderer2.component';
import { environment } from 'src/environments/environment';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { ApiHttpService } from "../../../_services/api-http.service";

import { MerchantFilter, MerchantService } from '../merchants/merchant-master/merchant.service';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';

const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

export interface DocumentFilter {
  "documentType"?: string,
  "merchantName"?: string,
  "uploadedDate"?: string,
  "signedCompletionDate"?: string,
  "uploadedBy"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number
}

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
  @ViewChild('confirmModal') confirmModal: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;

  currentDate: any = new Date();
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxSignedDate: NgbDateStruct;
  maxUploadedDate: NgbDateStruct;

  currentPage: number = 1;
  Resultdata: any;
  merchantId: any;
  loading: boolean = false;
  UBOList: any = [];
  merchantSelected = false;
  documentTypeEntry = null;
  merchantNameEntry = null;
  merchantIdEntry = null;

  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  pageRecords: number = defaultPageSize;
  pageNumber: number = 1;

  private gridApi!: GridApi;
  private gridColumnApi!: any;
  public rowData: any = [];
  globalSearch: string = '';
  public defaultColDef: ColDef = { flex: 1, minWidth: 185, resizable: true, sortable: true, filter: false, autoHeight: true };
  collectionSize: number = 0;

  status: any;
  docPath: any;
  collectiondata: number = 0;
  totalRecords: any;
  documentdata: any;
  uploadedFile: File | null = null;
  fileNotSelected: boolean = false;
  fileErrorMessage: string | null = null;
  closeResult = '';
  private modalRef: any;


  public quickFilterShow: boolean = false;
  public documentType: string;
  public merchantName: string;
  public uploadedDate: NgbDateStruct | null;
  public signedCompletionDate: NgbDateStruct | null;
  public uploadedBy: string;


  @ViewChild('filSignedDate') private filSignedDate: FormControl;
  @ViewChild('filUploadedDate') private filUploadedDate: FormControl;

  public columnDefs: ColDef[] = [
    { field: 'documentId', lockVisible: true, headerName: 'Document ID' },
    { field: 'merchantName', lockVisible: true, headerName: 'Merchant Name' },
    { field: 'uploadedBy', lockVisible: true, headerName: 'Uploaded By' },
    { field: 'uploadedDate', lockVisible: true, headerName: 'Uploaded On' },
    { field: 'signedCompletionDate', lockVisible: true, headerName: 'Signed On' },
    { field: 'documentType', lockVisible: true, headerName: 'Document Type' },
    {
      field: 'status',
      lockVisible: true,
      headerName: 'Status',
      cellRenderer: (params: any) => {
        const status = (params.value || '').toUpperCase();
        let badgeClass = '';
        let statusText = '';
        switch (status) {
          case 'SIGNED': badgeClass = 'badge-success'; statusText = 'SIGNED'; break;
          case 'SENT': badgeClass = 'badge-warning'; statusText = 'SENT'; break;
          case 'FAILED': badgeClass = 'badge-danger'; statusText = 'FAILED'; break;
          case 'REVOKED': badgeClass = 'badge-secondary'; statusText = 'REVOKED'; break;
          default: badgeClass = ''; statusText = ''; break;
        }
        return `<span class="badge ${badgeClass}">${statusText}</span>`;
      }
    },
    {
      field: 'actions',
      lockVisible: true,
      headerName: 'Actions',
      width: 30,
      cellRenderer: BtnCellRenderer2,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            if (param.data.documentId) this.downloadDocument(param.data.docPath, param.data.docPath);
          },
          buttonIconClass: 'icon-download',
          isButtonVisible: (params: ICellRendererParams) => {
              return params.data && params.data.status;
            }
        },
        {
          clicked: async (event: any, param: any) => {
            if (param.data.documentId) this.deleteUnsignedDocument(param.data.documentId);
          },
          buttonIconClass: 'icon-trash',
          isButtonVisible: (params: ICellRendererParams) => {
            return params.data && params.data.status && (params.data.status.toUpperCase() !== 'REVOKED' && params.data.status.toUpperCase() !== 'SIGNED');
          }
        }
      ]
    },
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private router: Router, private alertService: AlertService, private apiHttpService: ApiHttpService,
    private _DS: DocumentUploadService, private modalService: NgbModal, private fb: FormBuilder, private ngbDateParserFormatter: NgbDateParserFormatter, private merchantService: MerchantService,
    private calendar: NgbCalendar, private exportTrackingService: ExportTrackingService
  ) {
    this.maxSignedDate = this.calendar.getToday();
    this.maxUploadedDate = this.calendar.getToday();
    this.maxDate = this.calendar.getToday();
    this.minDate = this.calendar.getToday();
  }

  ngOnInit(): void {
    this.getDocumentList();
  }

  getDocumentList() {
    this._DS.getDocumentList(null, this.pageRecords, this.pageNumber - 1).subscribe((data: any) => {
      this.rowData = data.response.data.content;
      this.collectiondata = data.response.data.content;
      this.collectionSize = data.response.data.totalElements;
      this.totalRecords = data.response.data.totalElements;
      if (data.response.data.content.length == 0) {
        this.alertService.errorAlertWithMessage("No records present");
      }
    });
  }

  downloadDocument(id: string, docPath: string): void {
    this._DS.downloadDocument(id).subscribe(
      (data: any) => {
        const file = new Blob([data]);
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        const fileName = docPath.split('/').pop() || 'download';
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(fileURL);
      },
      (error: any) => {
        this.alertService.errorAlertWithMessage('An error occurred while downloading the file');
      }
    );
  }

  deleteUnsignedDocument(id: string): void {
    this._DS.deleteUnsignedDocument(id).subscribe(
      (data: any) => {
        console.log('dataaa : ', data.response.data);
        if(data.response.data) {
        this.alertService.successAlertWithAcknowledgment(data.response.message);
        this.ngOnInit();
        } else {
          this.alertService.errorAlertWithMessage(data.response.message);
        }
      },
      (error: any) => {
        console.log("error : " , error);
        this.alertService.errorAlertWithMessage("Unable to delete the document");
      }
    );
  }

  // openModal(content: any) {
  //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then(
  //     (result) => { this.closeResult = `Closed with: ${result}`; },
  //     (reason) => { this.closeResult = `Dismissed ${this.getDismissReason(reason)}`; }
  //   );
  // }

  openModalConfirm(content: any) {
    this.modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: false,
      modalDialogClass: 'modal-fullscreen'
    });

    const filter: MerchantFilter = {}
    this.merchantService.getMerchantList("","","", "", "", "", "", filter, "ALL", 0).subscribe((response) => {
      this.UBOList = [];
      this.merchantSelected = false;
      this.Resultdata = response.content;
    });

    this.modalRef.result.then(
      (result: any) => {
        if (result === 'submitted') {
          this.ngOnInit(); // Or call the relevant data-loading function
        }
      },
      (reason: any) => { this.closeResult = `Dismissed ${this.getDismissReason(reason)}`; }
    );
  }

  onSelectMerchant(event: any) {
    this.merchantNameEntry = event.fullName;
    this.merchantIdEntry = event.userId;
    this.merchantSelected = false;
    this.merchantService.getUBO(event.userId).subscribe((response: any) => {
      this.UBOList = response.response.data.data
        .filter((item: any) => item?.emailId?.trim() && item?.eid?.toString().trim())
        .map((item: any, index: number) => ({
          signatoryEmail: item.emailId,
          signatoryName: item.shareHolderName,
          eid: item.eid,
          sequence: index + 1
        }));
      this.merchantSelected = true;
    })
  }

  private getDismissReason(reason: any): string {
    return reason === 'ESC' ? 'by pressing ESC' : reason === 'BACKDROP_CLICK' ? 'by clicking on a backdrop' : `with: ${reason}`;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const allColumnIds: (string | any)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
  }

  onPageSizeChanges(eve: any) {
    this.pageNumber = 1;
    this.getDocumentList();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param;
    this.getDocumentList();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  findMatchingObjects(keys: string[]): any[] {
    let expData: any = [];
    this.rowData.forEach((curr: any) => {
      const tempRec: any = {};
      keys.forEach((col) => {
        const column: any = this.gridColumnApi.getColumn(col);
        if (column.visible) {
          tempRec[col] = curr[col];
        }
      });
      expData.push(tempRec);
    });
    return expData;
  }

  onRowClicked(param: RowClickedEvent | any) { }

  cancel() {
    this.modalService.dismissAll();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        this.fileErrorMessage = 'Only PDF files are allowed.';
        this.uploadedFile = null;
      } else if (file.size > 5 * 1024 * 1024) {
        this.fileErrorMessage = 'File size must be less than 5MB.';
        this.uploadedFile = null;
      } else {
        this.uploadedFile = file;
        this.fileErrorMessage = null;
      }
    }
  }

  replaceFile() {
    this.uploadedFile = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.fileErrorMessage = null;
  }

  submitForm() {
    const formData = new FormData();

    if (this.uploadedFile) {
      formData.append('file', this.uploadedFile);
    }
    console.log('this.UBOList ', this.UBOList.size);
    if (this.UBOList.size > 5) {

    }
    formData.append('merchants', new Blob([JSON.stringify(this.UBOList)], { type: 'application/json' }));
    if (this.documentTypeEntry) {
      formData.append('documentType', this.documentTypeEntry);
    }
    if (this.merchantNameEntry) {
      formData.append('merchantName', this.merchantNameEntry);
    }
    if (this.merchantIdEntry) {
      formData.append('merchantId', this.merchantIdEntry);
    }

    this._DS.uploadDocument(formData).subscribe((data: any) => {
      console.log(data);
      this.resetPopup();
      this.modalRef.close('submitted');
    })
  }

  onSubmit() {
    // if (this.uploadForm.valid && this.uploadedFile) {
    //   const formData = new FormData();
    //   formData.append('file', this.uploadedFile);
    //   formData.append('merchantName', this.uploadForm.get('merchantName')?.value);
    //   formData.append('merchantEmail', this.uploadForm.get('merchantEmail')?.value);
    //   formData.append('documentType', this.uploadForm.get('documentType')?.value);
    //   this._DS.uploadDocument(formData).subscribe((data: any) => {
    //     if (data.response.status === 200) {
    //       this.getDocumentList();
    //       this.replaceFile();
    //       this.cancel();
    //       this.resetForm();
    //       this.alertService.toastSuccessMessageAlert({ title: data.response.message });
    //     } else {
    //       this.alertService.toastErrorMessageAlert({ title: data.response.message });
    //     }
    //   });
    // }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.onFileSelected({ target: { files: [files[0]] } });
    }
  }

  onFilterChange(param: FilterChangedEvent | any) {
  }

  onSortChange(event: any) {
    // console.log("==Sort===>", event);
  }

  onFilterModified(param: FilterModifiedEvent | any) {
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    // console.log("onFilterOpened----->", param);
  }

  updateSelectedColumn(event: any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    // if (!this.quickFilterShow) {
    //   // this.searchToDate = '';
    //   // this.searchFromDate = '';
    //   // this.searchMID = '';
    //   // this.searchMerName = '';
    //   // this.resellerPartnerId= '',
    //   // this.Status= ''
    //   this.filSearchMerName.handleClearClick();
    //   this.filSearchMID.handleClearClick();
    //   this.filResellerPartnerId.handleClearClick();
    //   this.filStatus.handleClearClick();
    //   this.searchFromDate = this.ngbCalender.getToday();
    //   this.searchToDate = this.ngbCalender.getToday();
    //   this.refreshGrid();
    // }
  }

  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }

  onSearchBtnClick() {
    const filter: DocumentFilter = {}

    if (this.documentType != undefined) {
      filter.documentType = this.documentType;
    } else {
      filter.documentType = "";
    }

    if (this.merchantName != undefined) {
      filter.merchantName = this.merchantName;
    } else {
      filter.merchantName = "";
    }

    if (this.uploadedBy != undefined) {
      filter.uploadedBy = this.uploadedBy;
    } else {
      filter.uploadedBy = "";
    }

    if (this.ngbDateParserFormatter.format(this.signedCompletionDate) == "" || this.ngbDateParserFormatter.format(this.signedCompletionDate) == "0-00-00") {
      filter.signedCompletionDate = "";
    } else {
      filter.signedCompletionDate = this.ngbDateParserFormatter.format(this.signedCompletionDate);
    }

    if (this.ngbDateParserFormatter.format(this.uploadedDate) == "" || this.ngbDateParserFormatter.format(this.uploadedDate) == "0-00-00") {
      filter.uploadedDate = "";
    } else {
      filter.uploadedDate = this.ngbDateParserFormatter.format(this.uploadedDate);
    }

    return this._DS.getDocumentList(filter, this.pageSize, this.pageNumber - 1)
      .subscribe((data: any) => {
        this.rowData = data.response.data.content;
        this.rowData = data.response.data.content;
        this.collectiondata = data.response.data.content
        this.collectionSize = data.response.data.totalElements
        this.totalRecords = data.response.data.totalElements
        if (data.response.data.content.length == 0) {
          console.log("No data");
          this.alertService.errorAlertWithMessage("No records present");
        }
      })
  }


  resetFilter() {
    // Reset all filter values
    this.documentType = '';
    this.merchantName = '';
    this.uploadedBy = '';
    this.signedCompletionDate = null;
    this.uploadedDate = null;


    this.pageNumber = 1;


    this.getDocumentList();


    if (this.filSignedDate) {
      this.filSignedDate.reset();
    }
    if (this.filUploadedDate) {
      this.filUploadedDate.reset();
    }
  }

  changeSignedDate() {
    this.currentDate = this.signedCompletionDate;
    // if (this.signedCompletionDate) {
    //   this.maxSignedDate = this.signedCompletionDate;
    // } else {
      this.maxSignedDate = this.calendar.getToday();
    //}
  }

  changeUploadedDate() {
    this.currentDate = this.uploadedDate;
    if (this.uploadedDate) {
      this.maxUploadedDate = this.uploadedDate;
    } else {
      this.maxUploadedDate = this.calendar.getToday();
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.UBOList, event.previousIndex, event.currentIndex);
    this.UBOList.forEach((m: any, i: any) => m.sequence = i + 1);
  }

  resetPopup() {
    this.UBOList = [];
    this.merchantSelected = false;
    this.uploadedFile = null;
    this.documentTypeEntry = null;
    this.merchantIdEntry = null;
    this.merchantNameEntry = null;
  }

  removeRow(index: number) {
    this.UBOList.splice(index, 1);

    this.UBOList.forEach((m: any, i: any) => {
      m.sequence = i + 1;
    });
  }

  enableButton() {
    return this.merchantSelected && this.UBOList.length > 0 && this.UBOList.length < 6 && this.uploadedFile && this.documentTypeEntry != null
  }

  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Document_Master' + "_" + referenceId;
    const filter: DocumentFilter = {}

    if (this.documentType != undefined) {
      filter.documentType = this.documentType;
    } else {
      filter.documentType = "";
    }

    console.log("--------------", filter.documentType);

    if (this.merchantName != undefined) {
      filter.merchantName = this.merchantName;
    } else {
      filter.merchantName = "";
    }

    console.log("--------------", filter.merchantName);

    if (this.uploadedBy != undefined) {
      filter.uploadedBy = this.uploadedBy;
    } else {
      filter.uploadedBy = "";
    }
    console.log("--------------", filter.uploadedBy);

    console.log('this.signedCompletionDate', this.signedCompletionDate);
    if (this.ngbDateParserFormatter.format(this.signedCompletionDate) == "" || this.ngbDateParserFormatter.format(this.signedCompletionDate) == "0-00-00") {
      filter.signedCompletionDate = "";
    } else {
      filter.signedCompletionDate = this.ngbDateParserFormatter.format(this.signedCompletionDate);
    }
    console.log("--------------", filter.signedCompletionDate);
    if (this.ngbDateParserFormatter.format(this.uploadedDate) == "" || this.ngbDateParserFormatter.format(this.uploadedDate) == "0-00-00") {
      filter.uploadedDate = "";
    } else {
      filter.uploadedDate = this.ngbDateParserFormatter.format(this.uploadedDate);
    }
    console.log("--------------", filter.uploadedDate);
    return this._DS.getDocumentList(filter, this.pageSize, this.pageNumber - 1)
      .subscribe((data: any) => {
        if (this.rowData.length <= 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }

        const expData: any[] = [];
        console.log(data.response.data.content);
        (data.response.data.content || data || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if (!(col?.field == "actions")) {
              if (col?.field) tempRec[col?.field] = curr[col?.field]
            }
          })
          expData.push(tempRec);
        })
        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'DOCUMENT_MANAGEMENT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Document management export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
      const tempRec: any = []
      var index=0;
      this.tableSelectedColumn.forEach((col) => {
        if(!( col?.field=="actions"))
        {
         tempRec[index] = col
         index++;
      }})
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
        // @ts-ignore
        header: [...tempRec.map((col:any) => col.headerName)]
      });
      // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      const wb = XLSX.utils.book_new();
      XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
      XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
      XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      documentType: this.documentType || '',
      merchantName: this.merchantName || '',
      uploadedBy: this.uploadedBy || '',
      status: this.status || '',
      uploadedDate: this.uploadedDate ? `${this.uploadedDate.year}-${this.uploadedDate.month}-${this.uploadedDate.day}` : '',
      signedCompletionDate: this.signedCompletionDate ? `${this.signedCompletionDate.year}-${this.signedCompletionDate.month}-${this.signedCompletionDate.day}` : ''
    };
  }
}